module.exports = {"name":"@atlaskit/tooltip","version":"16.0.0","sideEffects":false}